<script>
// Extensions
import View from '@/views/View'

// Mixins
import LoadSections from '@/mixins/load-sections'

export default {
    name: 'shop',

    metaInfo: {
        title: 'NEO Center Shop'
    },

    extends: View,

    mixins: [
        LoadSections([
            'shop',
        /*    'hero-alt',
            'theme-features',
            'affiliates',
            'newsletter',
            'pro-features',
            'info', */
        ]),
    ],

    props: {
        id: {
            type: String,
            default: 'shop',
        },
    },
}
</script>